import { atom, selector } from "recoil"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"

export const kanaLastNameState = atom({
  key: "atoms/account/kanaLastNameState",
  default: selector({
    key: "atoms/account/kanaLastNameState_default",
    get: ({ get }) => {
      const account = get(accountSelector)
      return account?.kanaLastName
    },
  }),
})
